import { Fragment, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { PageVisitToast } from '@/core/error/PageVisitToast';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { Loader } from './Loader';
import { TapTop } from './TapTop';
import { useTheme } from './ThemeContext';

export function AppLayout() {
  const { layout, sidebarIconType } = useTheme();

  return (
    <Fragment>
      <PageVisitToast />
      <Loader />
      <TapTop />
      <div
        className={`page-wrapper ${layout}`}
        sidebar-layout={sidebarIconType}
        id="pageWrapper"
      >
        <Header />
        <div className="page-body-wrapper">
          <Sidebar />
          <div className="page-body">
            <div>
              <div>
                <Suspense fallback={null}>
                  <Outlet />
                </Suspense>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </Fragment>
  );
}

export const AdminShell = AppLayout;
